module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Ghostly Tales of Lake Tahoe")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AP")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "320px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Welcome_to_Spooky_Lake_Tahoe#Wel"
    }
  }, [_vm._v("Welcome to Spooky Lake Tahoe!")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mythical Beasts of Tahoe")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lake Never Gives Up Its Dead")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _c('td', [_vm._v("Hellman-Ehrman Mansion")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _c('td', [_vm._v("Emerald Bay")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghostly Thunderbird Lodge")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spooky Shores and Summits")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _c('td', [_vm._v("Shakespeare Point")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _c('td', [_vm._v("Genoa Peak")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7")]), _c('td', [_vm._v("Glenbrook")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebrity Ghosts at the Cal Neva")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Ghosts Named Mary")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9")]), _c('td', [_vm._v("Rainbow Lodge")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10")]), _c('td', [_vm._v("Tahoe Biltmore Lodge & Casino")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Highways")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hard Rock Hauntings")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terrified in Truckee")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13")]), _c('td', [_vm._v("Old Jail Museum")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("14")]), _c('td', [_vm._v("The Richardson House")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sad Tale of the Donner Party")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/A_Ghostly_Goodbye#Gho",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ghostly Goodbye")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0